export const es = {
  nav: {
    discover: "Discover",
    creators: "Creadores",
    howItWorks: "Cómo funciona",
    forCreators: "Para creadores",
    about: "Nosotros",
    legal: "Legal",
    waitlist: "Unirme a la lista",
    signIn: "Iniciar sesión",
    comingSoon: "Próximamente",
    menu: "Menú",
  },
  hero: {
    badge18: "18+",
    comingSoon: "Próximamente",
    eyebrow: "The Experience Engine",
    lines: ["Descubre creadores.", "Vive su experiencia."],
    sub: "Una nueva forma de descubrir contenido exclusivo, conectar con creadores y desbloquear experiencias que van más allá de un simple post.",
    definition: "GOOX es una plataforma de contenido exclusivo para adultos que conecta creadores y fans a través de experiencias digitales.",
    ctaFans: "Descubre GOOX",
    ctaCreators: "Ser creador",
    devNotice: "GOOX está actualmente en desarrollo. El registro, las compras y la subida de contenido aún no están disponibles.",
    steps: ["Discover", "Choose", "Unlock", "Collect", "Connect"],
    card1Label: "Próximo live · Concepto",
    card1Title: "Entrenamiento en vivo — solo suscriptores",
    card1Creator: "Kai Moreno · perfil ficticio",
    card2Label: "Lanzamiento exclusivo · Concepto",
    card2Title: "Midnight — Bundle de lanzamiento",
    card2Meta: "Limitado · 100 unidades · ventana transparente",
    operated: "Operado por CAP GROUP S.A.S. · Colombia",
  },
  marquee: ["Discover", "Choose", "Unlock", "Collect", "Connect", "Live", "Series", "Colecciones", "Lanzamientos limitados"],
  what: {
    eyebrow: "01 — Qué es GOOX",
    title: "Más que contenido. Una experiencia.",
    body: "GOOX es una plataforma de contenido exclusivo para adultos (18+) que conecta a creadores y fans a través de experiencias digitales: suscripciones, colecciones, series, lanzamientos limitados y experiencias personalizadas. Cada pieza se presenta como un producto: valor claro, precio transparente y sin mecánicas ocultas.",
    pillars: [
      { t: "Valor transparente", d: "Los fans ven exactamente qué desbloquean antes de pagar. Sin sorpresas ni patrones oscuros." },
      { t: "Escasez real", d: "Lanzamientos limitados con unidades y ventanas visibles — nunca cuentas regresivas artificiales." },
      { t: "Propiedad del creador", d: "Los creadores mantienen el control de su catálogo, sus precios y la relación con su audiencia." },
    ],
  },
  creators: {
    eyebrow: "02 — Para creadores",
    title: "Tu contenido. Tu audiencia. Tu negocio.",
    sub: "Un estudio diseñado para convertir un catálogo en un negocio — con herramientas para publicar, empaquetar y entender tus ingresos.",
    items: [
      { t: "Crea tu perfil", d: "Una página pública que presenta tu identidad, tu catálogo y tus ofertas exclusivas." },
      { t: "Publica contenido", d: "Posts, fotos, video y audio con controles de visibilidad granulares." },
      { t: "Construye colecciones", d: "Agrupa piezas en bundles temáticos con su propio precio e historia." },
      { t: "Crea series", d: "Publica contenido por episodios — como quests que tus fans siguen en el tiempo." },
      { t: "Lanza ediciones exclusivas", d: "Drops limitados con unidades, fechas y ventanas transparentes." },
      { t: "Conecta con tus fans", d: "Mensajería directa, momentos en vivo y relaciones más cercanas." },
      { t: "Sigue tus ganancias", d: "Un panel claro de ingresos, desbloqueos y crecimiento de audiencia." },
    ],
    cta: "Ser creador",
  },
  fans: {
    eyebrow: "03 — Para fans",
    title: "Descubre creadores que te van a encantar.",
    sub: "Ven a descubrir, no solo a suscribirte. Cada perfil muestra el valor antes de que decidas.",
    items: [
      { t: "Descubre", d: "Explora creadores por categoría, estilo y formato." },
      { t: "Sigue", d: "Mantente cerca de los creadores que te importan." },
      { t: "Suscríbete", d: "Acceso recurrente al mundo exclusivo de un creador." },
      { t: "Desbloquea", d: "Paga una vez por una pieza, colección o lanzamiento." },
      { t: "Colecciona", d: "Construye tu biblioteca personal de experiencias desbloqueadas." },
      { t: "Apoya creadores", d: "Tu apoyo llega directamente a las personas que sigues." },
    ],
    cta: "Unirme a la lista de espera",
  },
  engine: {
    eyebrow: "04 — The Experience Engine",
    title: "Convierte contenido en experiencias.",
    sub: "La misma pieza de contenido puede convertirse en muchos productos. GOOX da a los creadores los formatos; los fans obtienen claridad sobre lo que desbloquean.",
    source: "Contenido",
    outputs: [
      { k: "POST", t: "Post", d: "Publicación pública o solo para suscriptores." },
      { k: "PPV", t: "Pago por ver", d: "Pieza individual, desbloqueada una sola vez." },
      { k: "COLLECTION", t: "Colección", d: "Bundle curado con su propio precio." },
      { k: "SERIES", t: "Serie", d: "Lanzamientos episódicos que los fans siguen." },
      { k: "RELEASE", t: "Lanzamiento exclusivo", d: "Drop limitado con unidades visibles." },
      { k: "LIVE", t: "Live", d: "Momentos en tiempo real para suscriptores." },
    ],
  },
  how: {
    eyebrow: "05 — Cómo funciona",
    title: "Cinco pasos. Cero fricción.",
    steps: [
      { n: "01", t: "Discover", d: "Explora creadores públicamente — sin cuenta para mirar." },
      { n: "02", t: "Choose", d: "Compara formatos: suscripción, desbloqueo único, colección o lanzamiento." },
      { n: "03", t: "Unlock", d: "Paga con un precio claro y una descripción clara. Siempre." },
      { n: "04", t: "Collect", d: "Todo lo que desbloqueas vive en tu biblioteca." },
      { n: "05", t: "Connect", d: "Envía mensajes, entra a lives y sigue series mientras se publican." },
    ],
  },
  waitlist: {
    eyebrow: "Pre-lanzamiento",
    title: "Únete a la lista de espera de GOOX",
    sub: "Sé el primero en saber cuándo abre GOOX. Solo usaremos tu correo para contactarte sobre el lanzamiento.",
    email: "Correo electrónico",
    emailPh: "tu@correo.com",
    iam: "Soy",
    roles: { fan: "Fan", creator: "Creador", agency: "Agencia / Estudio" },
    consent: "Autorizo a CAP GROUP S.A.S. a tratar mis datos personales para contactarme sobre el lanzamiento de GOOX, conforme a la",
    consentLink: "Política de Privacidad",
    consentRequired: "Debes aceptar la autorización de tratamiento de datos.",
    submit: "Unirme a la lista",
    submitting: "Enviando…",
    success: "Estás en la lista. Te avisaremos cuando GOOX abra.",
    duplicate: "Este correo ya está en la lista de espera.",
    error: "Algo salió mal. Inténtalo de nuevo.",
    invalidEmail: "Ingresa un correo electrónico válido.",
    note: "No se crea ninguna cuenta. No se solicita ningún pago.",
  },
  footer: {
    tagline: "La nueva experiencia para creadores.",
    platform: "Plataforma",
    company: "Empresa",
    legal: "Legal",
    forFans: "Para fans",
    forCreators: "Para creadores",
    contact: "Contacto",
    rights: "Todos los derechos reservados.",
    ageNotice: "Este sitio web está dirigido a personas mayores de 18 años. GOOX es una presentación de pre-lanzamiento; aún no hay cuentas de usuario, compras ni contenido de usuarios.",
    operatedBy: "GOOX es una marca operada por",
  },
  legalTitles: {
    terms: "Términos y Condiciones",
    privacy: "Política de Privacidad",
    cookies: "Política de Cookies",
    refunds: "Política de Reembolsos",
    content: "Política de Contenido",
    dmca: "DMCA / Derechos de autor",
    "age-safety": "Edad y Seguridad",
    "creator-terms": "Términos para Creadores",
    "acceptable-use": "Política de Uso Aceptable",
    complaints: "Quejas / Contacto",
  },
  legal: {
    title: "Legal",
    sub: "Políticas que rigen el sitio de pre-lanzamiento de GOOX y la futura plataforma, operados por CAP GROUP S.A.S.",
    updated: "Última actualización",
    disclaimer: "Documentos borrador elaborados específicamente para GOOX y CAP GROUP S.A.S. Las versiones definitivas están sujetas a revisión por asesoría legal en Colombia.",
    toc: "Documentos",
    back: "Volver al inicio",
  },
  discover: {
    eyebrow: "Vista conceptual",
    title: "Descubre creadores.",
    sub: "Una vista conceptual de la experiencia Discover de GOOX. Todos los perfiles son ficticios y todo el contenido es un marcador de posición.",
    notice: "Demo conceptual — perfiles ficticios, sin contenido real, sin compras. Las interacciones se habilitarán cuando la plataforma lance.",
    search: "Buscar creadores, colecciones…",
    all: "Todos",
    follow: "Seguir",
    subscribe: "Suscribirse",
    locked: "Bloqueado",
    pieces: "piezas",
    fans: "fans",
    fictional: "Perfil ficticio",
    comingSoon: "Próximamente",
    empty: "Ningún creador coincide con tu búsqueda.",
  },
  about: {
    eyebrow: "Sobre GOOX",
    title: "Una plataforma para creadores construida en Colombia, diseñada para el mundo.",
    intro: "GOOX es una plataforma de contenido exclusivo para adultos (18+) operada por CAP GROUP S.A.S., una sociedad constituida en Colombia. GOOX se está desarrollando como una plataforma que conecta a creadores, agencias y fans a través de contenido digital exclusivo, suscripciones y experiencias digitales.",
    statusTitle: "Estado actual",
    status: "GOOX está en desarrollo. Este sitio web es una presentación pública de pre-lanzamiento: explica la marca, el modelo de negocio y el marco legal, y recoge una lista de espera. El registro, los pagos, la subida de contenido y el acceso a contenido real aún no están disponibles.",
    missionTitle: "Misión",
    mission: "Dar a los creadores un lugar profesional para convertir su trabajo en experiencias claras y con precios justos — y dar a los fans transparencia sobre lo que desbloquean.",
    modelTitle: "Modelo de negocio (planeado)",
    model: [
      { t: "Suscripciones", d: "Acceso mensual recurrente al contenido exclusivo de un creador." },
      { t: "Desbloqueos pago por ver", d: "Compra única de una pieza, colección o serie." },
      { t: "Lanzamientos exclusivos", d: "Drops de cantidad limitada con unidades y ventanas de tiempo visibles." },
      { t: "Experiencias en vivo", d: "Sesiones en tiempo real para suscriptores o con entrada." },
      { t: "Comisión de plataforma", d: "GOOX retiene un porcentaje de cada transacción; el resto se paga al creador." },
    ],
    complianceTitle: "Compromisos de cumplimiento",
    compliance: [
      "Solo 18+: todos los usuarios y creadores deben ser adultos; los creadores completarán verificación de identidad y edad (KYC) antes de publicar.",
      "Moderación de contenido: una política de contenido, un proceso de revisión y un procedimiento de retiro aplican a todo el material publicado.",
      "Derechos de autor: proceso de notificación y retiro DMCA / derechos de autor con un contacto designado.",
      "Protección al consumidor: precios transparentes, descripciones claras y una política de reembolsos escrita.",
      "Protección de datos: datos personales tratados bajo la Ley 1581 de 2012 y el Decreto 1377 de 2013 de Colombia.",
      "Pagos: procesados exclusivamente a través de proveedores de servicios de pago autorizados; GOOX nunca almacena datos de tarjetas.",
    ],
    companyTitle: "Entidad legal",
    fields: {
      legalName: "Razón social",
      nit: "NIT",
      registry: "Matrícula mercantil No.",
      chamber: "Registrada en",
      registeredAt: "Fecha de matrícula",
      renewedAt: "Última renovación",
      niif: "Grupo NIIF",
      address: "Domicilio principal",
      email: "Correo electrónico",
      phones: "Teléfono",
      domain: "Dominio",
      brand: "Marca",
    },
    roadmapTitle: "Hoja de ruta",
    roadmap: [
      { n: "Fase 1", t: "Landing + Lista de espera + Legal", d: "Presentación pública de marca y documentación lista para underwriting.", now: true },
      { n: "Fase 2", t: "Discover + perfiles públicos", d: "Exploración pública de creadores y catálogos." },
      { n: "Fase 3", t: "Registro de fans y creadores", d: "Cuentas, verificación y onboarding de creadores." },
      { n: "Fase 4", t: "Plataforma completa", d: "Suscripciones, desbloqueos, lanzamientos, lives, wallet y pagos." },
      { n: "Fase 5", t: "GOOX internacional", d: "Expansión multimoneda y multilenguaje." },
    ],
    contactTitle: "Contacto",
    contact: "Para consultas comerciales, de cumplimiento o legales, contacta a CAP GROUP S.A.S. con los datos anteriores o a través de la página de Quejas / Contacto.",
    current: "Fase actual",
  },
  admin: {
    title: "Admin de lista de espera",
    sub: "Área restringida · CAP GROUP S.A.S.",
    password: "Contraseña de administrador",
    login: "Entrar",
    loggingIn: "Entrando…",
    logout: "Salir",
    invalid: "Contraseña incorrecta.",
    locked: "Demasiados intentos. Inténtalo de nuevo en 15 minutos.",
    total: "Registros totales",
    fans: "Fans",
    creators: "Creadores",
    agencies: "Agencias",
    search: "Buscar por correo…",
    all: "Todos los roles",
    export: "Exportar CSV",
    refresh: "Actualizar",
    empty: "Aún no hay registros.",
    delete: "Eliminar",
    deleted: "Registro eliminado.",
    cols: { email: "Correo", role: "Rol", lang: "Idioma", date: "Fecha", consent: "Consentimiento" },
    roles: { fan: "Fan", creator: "Creador", agency: "Agencia / Estudio" },
  },
  notFound: { title: "Página no encontrada", body: "Esta página no existe o aún no está disponible.", cta: "Volver al inicio" },
  status: {
    eyebrow: "06 — Estado de la plataforma",
    title: "Plataforma actualmente en desarrollo.",
    body: "GOOX es una presentación de pre-lanzamiento. Lo que ves aquí es la marca, el modelo de negocio y el marco legal. El registro, los pagos, la subida de contenido y el acceso a contenido real aún no están disponibles.",
    operatedBy: "Operada por",
    entity: "Entidad legal",
    canTitle: "Qué puede hacer un visitante hoy",
    can: ["Explorar la marca y cómo funciona GOOX", "Ver la vista conceptual de Discover (perfiles ficticios)", "Leer la información corporativa y todas las políticas legales", "Unirse a la lista de espera como fan, creador o agencia"],
    cannotTitle: "Aún no disponible",
    cannot: ["Crear una cuenta o iniciar sesión", "Comprar, suscribirse o desbloquear contenido", "Subir o publicar contenido", "Enviar mensajes a creadores o entrar a lives"],
    aboutCta: "Sobre GOOX y CAP GROUP S.A.S.",
    legalCta: "Documentos legales",
  },
  login: {
    eyebrow: "Iniciar sesión",
    title: "GOOX se está preparando para el lanzamiento.",
    body: "Únete a la lista de espera para recibir un aviso cuando el acceso esté disponible. Todavía no existen cuentas públicas de usuario — y no pretendemos aparentar lo contrario.",
    cta: "Unirme a la lista de espera",
    back: "Volver al inicio",
    demoEyebrow: "Acceso demo / revisores",
    demoTitle: "Cuenta demo para procesadores de pago y revisores",
    demoBody: "Una cuenta sandbox que muestra cómo se verá y funcionará el área de miembros de GOOX. Creadores ficticios, contenido de relleno y transacciones simuladas — no se procesa ningún pago real.",
    username: "Usuario demo",
    password: "Contraseña demo",
    submit: "Entrar a la demo",
    submitting: "Entrando…",
    invalid: "Usuario o contraseña incorrectos.",
    locked: "Demasiados intentos. Inténtalo de nuevo en 15 minutos.",
  },
  demo: {
    banner: "Cuenta demo — vista conceptual para revisores. Perfiles ficticios, contenido de relleno, transacciones simuladas. No se procesa ningún pago real.",
    ribbon: "DEMO",
    nav: { home: "Inicio", discover: "Discover", following: "Siguiendo", collections: "Colecciones", messages: "Mensajes", wallet: "Wallet", profile: "Perfil", live: "Live", library: "Mi biblioteca", security: "Seguridad", studio: "Creator Studio", signOut: "Cerrar sesión", fanView: "Vista de fan", creatorView: "Vista de creador", backToSite: "Volver a goox.vip" },
    search: "Buscar creadores, piezas…",
    tokens: "tokens",
    add: "Añadir",
    toastPay: "Modo demo: las compras y los pagos están deshabilitados.",
    toastMsg: "Modo demo: la mensajería es de solo lectura.",
    types: { POST: "Post", PPV: "Pago por ver", COLLECTION: "Colección", SERIES: "Serie", RELEASE: "Lanzamiento exclusivo", LIVE: "Live", SUB: "Suscripción" },
    home: {
      eyebrow: "The Experience Engine",
      line1: "No vengo solo a suscribirme.",
      line2: "Vengo a descubrir.",
      sub: "Cada pieza es un producto: Series por episodios, Lanzamientos limitados reales, Colecciones, Desbloqueos individuales y Lives. Ves el valor antes de pagar.",
      cta1: "Explorar Discover",
      cta2: "Ver Series",
      upcomingLive: "Próximo live",
      activeDrop: "Drop activo",
      dropsTitle: "Drops activos",
      dropsSub: "Escasez real: unidades visibles y ventanas transparentes.",
      viewAll: "Ver todo",
      feedTitle: "Para ti",
      feedSub: "Piezas de los creadores que sigues.",
      unlock: "Desbloquear",
      subscribe: "Suscribirse",
      unlocked: "Desbloqueado",
      subscribers: "Solo suscriptores",
      live: "EN VIVO",
      soldOut: "Agotado",
      presale: "Preventa",
      units: "uds",
    },
    following: { title: "Siguiendo", sub: "Creadores que sigues y tus suscripciones activas.", active: "Suscripción activa", renews: "Renueva", follow: "Siguiendo", subscribe: "Suscribirse", manage: "Gestionar", perMonth: "/mes" },
    collections: { title: "Mi biblioteca", sub: "Todo lo que desbloqueas vive aquí — para siempre.", pieces: "piezas", paid: "Pagado", open: "Abrir", acquired: "Adquirida" },
    messages: { title: "Mensajes", sub: "Conversaciones directas con los creadores que apoyas.", ppv: "Mensaje bloqueado", unlockFor: "Desbloquear por", placeholder: "Escribe un mensaje… (solo lectura en demo)", send: "Enviar" },
    wallet: {
      title: "Wallet", sub: "Los tokens son créditos prepagados para desbloquear piezas. Las suscripciones se cobran en USD.", balance: "Saldo de tokens", equivalent: "≈ equivalente en USD", addFunds: "Añadir tokens", packs: "Paquetes de tokens", buy: "Comprar",
      history: "Historial de transacciones", date: "Fecha", desc: "Descripción", amount: "Monto", method: "Medio de pago", processor: "Tarjeta vía PSP autorizado (simulado)", disabled: "Los pagos no están habilitados en la demo. En producción, todos los pagos con tarjeta serán procesados por un proveedor de servicios de pago autorizado; GOOX nunca almacena datos de tarjetas.",
      kinds: { topup: "Recarga", sub: "Suscripción", unlock: "Desbloqueo" },
    },
    profile: { title: "Perfil", sub: "Tu identidad en GOOX como fan.", username: "Usuario", email: "Correo", role: "Tipo de cuenta", member: "Miembro desde", status: "Estado", verified: "Edad verificada (18+)", demoRole: "Cuenta demo de fan", lang: "Idioma", edit: "Editar perfil" },
    security: { title: "Seguridad de la cuenta", sub: "Controles que tendrá toda cuenta de GOOX.", items: ["Autenticación en dos pasos (TOTP / correo)", "Sesiones activas y gestión de dispositivos", "Creadores y usuarios bloqueados", "Preferencias de visibilidad y privacidad del contenido", "Descargar tus datos / eliminar cuenta", "Estado de verificación de edad"] },
    studio: {
      title: "Creator Studio", sub: "Cómo ve su negocio en GOOX un creador verificado (datos demo).", earnings: "Ingresos · últimos 30 días", subscribers: "Suscriptores activos", unlocks: "Desbloqueos · 30 días", pending: "Pendiente (periodo de retención)", available: "Disponible para pago", nextPayout: "Próximo pago", request: "Solicitar pago",
      split: "Reparto de ingresos", splitNote: "de cada transacción va al creador; GOOX retiene la comisión de plataforma. Los pagos se liberan tras un periodo de retención por protección contra fraude y contracargos.", creator: "Creador", platform: "Comisión GOOX", holding: "días de retención",
      top: "Contenido destacado", type: "Tipo", sales: "Ventas", revenue: "Ingresos", payouts: "Historial de pagos", paid: "Pagado",
    },
  },
  ageGate: {
    eyebrow: "Verificación de edad",
    title: "Este sitio es solo para adultos.",
    body: "GOOX es una plataforma para creadores dirigida exclusivamente a personas mayores de 18 años. Al entrar confirmas que tienes al menos 18 años (o la mayoría de edad en tu jurisdicción) y que ver este tipo de contenido es legal en el lugar donde te encuentras.",
    legal: "Al entrar también aceptas nuestros",
    and: "y la política de",
    enter: "Tengo 18+ — Entrar",
    exit: "Menor de 18 — Salir",
    operated: "Operado por",
  },
};
